import moment from "moment";
import { useEffect, useMemo, useRef, useState } from "react";
import {
    mostraAlertaError,
    mostraAlertaOk,
} from "../../../../componentes/alerts/sweetAlert";
import { AxiosPrivado } from "../../../../componentes/axios/Axios";
import { ErroresPeticion } from "../../../../componentes/axios/ErroresPeticion";
import Card from "../../../../componentes/contenedores/Card";
import { IdentificarEstacion } from "../../../../componentes/estacion/Estacion";
import ModalWizardBootstrap from "../../../../componentes/modal/ModalWizardBootstrap";
import Page from "../../../../componentes/plantilla/Page";
import Tablas from "../../../../componentes/tablas/TablasGenerico";
import {
    CajaVerificar,
    CompraPagaCredito,
    ComprasListar,
    CompraListarId
} from "../../../../configuracion/apiUrls";
import { useContextEmpleado } from "../../../../contexto/empleado/EmpleadoContext";
import { formatoMoneda } from "../../../../configuracion/validaciones";
import MetodosPagoDinamicos from "../../../../componentes/metodos/MetodosPagos";
import ReporteCredito from "./ReporteCredito";
import { pdf } from '@react-pdf/renderer';
import Swal from "sweetalert2";

const HomeCredito = () => {
    const { listaCompras, ActualizarLista, setListaCompras, listaComprasFiltradas, setListaComprasFiltradas } = useContextEmpleado();
    const refEdicion = useRef(null);
    const [compraSeleccionada, setCompraSeleccionada] = useState(null);
    const [modalOpen2, setModalOpen2] = useState(false);
    const [efectivo, setEfectivo] = useState(0);
    const [pos, setPos] = useState(0);
    const [transferencias, setTransferencias] = useState(0);
    const [totalRecibido, setTotalRecibido] = useState(0);
    const [montosPos, setMontosPos] = useState({});
    const [montosTransferencia, setMontosTransferencia] = useState({});
    const [referenciasPos, setReferenciasPos] = useState({});
    const [referenciasTransferencia, setReferenciasTransferencia] = useState({});
    const [erroresReferenciaPos, setErroresReferenciaPos] = useState({});
    const [erroresReferenciaTransferencia, setErroresReferenciaTransferencia] = useState({});
    const [cajaId, setCajaId] = useState(null);
    const [cajaAbierta, setCajaAbierta] = useState(false);
    const [panelAbierto, setPanelAbierto] = useState(false);
    const [estadoFiltro, setEstadoFiltro] = useState("TODOS");
    const [estadoFiltroTemp, setEstadoFiltroTemp] = useState("TODOS");
    const [fechaInicio, setFechaInicio] = useState(
        moment().subtract(1, "days").format("YYYY-MM-DD")
    );
    const [fechaFin, setFechaFin] = useState(moment().format("YYYY-MM-DD"));

    const verificarYCargarCaja = async () => {
        try {
            const estacionDatos = await IdentificarEstacion();
            const response = await AxiosPrivado.post(CajaVerificar, { estacionDatos });
            if (response.data.estado === "CE") {
                mostraAlertaError("La caja ya está cerrada. No se puede registrar ventas.");
                return;
            }
            const caja = response.data;
            setCajaId(caja.id);
            setCajaAbierta(caja.estado !== "CE");
            return true;
            //mostraAlertaOk("Caja autenticada correctamente");
        } catch (error) {
            ErroresPeticion(error);
            //console.error("Autenticación de caja fallida:", error);
            return false;
        }
    };

    const [datosPago, setDatosPago] = useState({
        recibido: totalRecibido,
        tipoVenta: "Contado",
        documento: "FA",
        efectivo: [
            { monto: 500 }
        ],
        transferencia: [
            { monto: 1000, referencia: "900700027760", cuentaId: 1 }
        ],
        tarjeta: [
            { monto: 700, referencia: "900700027760", posId: 1 }
        ],
        montoCredito: 0,
        fecha: "",
        fechaVencimiento: "",
        saldo: 0,
    });

    useEffect(() => { }, [datosPago]);

    const actualizarListaPagos = () => {
        let tipoPagoValido = "Efectivo";

        if (totalRecibido > 0) {
            if (parseFloat(efectivo) > 0 && transferencias === 0 && pos === 0) {
                tipoPagoValido = "Efectivo";
            } else if (transferencias > 0 && pos === 0) {
                tipoPagoValido = "Transferencia";
            } else if (pos > 0 && transferencias === 0) {
                tipoPagoValido = "Tarjeta";
            } else {
                tipoPagoValido = "Mixto";
            }
        }

        let tipoVenta = "Contado";
        if (datosPago.documento === "CR") {
            tipoVenta = "Crédito";
        }

        let nPago = {
            pago: Total,
            recibido: totalRecibido,
            tipo: tipoPagoValido,
            documento: datosPago.documento,
            tipoVenta: tipoVenta,
            fecha: moment().format("YYYY-MM-DD"),
            efectivo:
                parseFloat(efectivo) > 0 ? [{ monto: parseFloat(efectivo) }] : [],
        };

        const listaTransferencias = Object.keys(montosTransferencia)
            .filter(cuentaId => parseFloat(montosTransferencia[cuentaId] || 0) > 0)
            .map(cuentaId => ({
                monto: parseFloat(montosTransferencia[cuentaId]),
                referencia: referenciasTransferencia[cuentaId] || "",
                cuentaId: parseInt(cuentaId, 10),
            }));

        if (listaTransferencias.length > 0) {
            nPago = { ...nPago, transferencia: listaTransferencias };
        }

        const listaPos = Object.keys(montosPos)
            .filter(posId => parseFloat(montosPos[posId] || 0) > 0)
            .map(posId => ({
                monto: parseFloat(montosPos[posId]),
                referencia: referenciasPos[posId] || "",
                posId: parseInt(posId, 10),
            }));

        if (listaPos.length > 0) {
            nPago = { ...nPago, tarjeta: listaPos };
        }

        setDatosPago(nPago);
    };

    useEffect(() => {
        const nuevoTotal = parseFloat(pos) + parseFloat(transferencias) + parseFloat(efectivo);
        if (nuevoTotal !== totalRecibido) setTotalRecibido(nuevoTotal);
        actualizarListaPagos();
        verificarYCargarCaja();
    }, [pos, transferencias, efectivo]);

    const limpiarDatosPago = () => {
        setEfectivo(0);
        setTotalRecibido(0);
        setPos(0);
        setTransferencias(0);
        setMontosPos({});
        setReferenciasPos({});
        setErroresReferenciaPos({});
        setMontosTransferencia({});
        setReferenciasTransferencia({});
        setErroresReferenciaTransferencia({});
    };

    /**
     * Fusiona el detalle sobre el objeto que ya venia del listado.
     * Conservador a proposito: si el endpoint de detalle no trae una clave,
     * o la trae vacia, se conserva la del listado. Asi el panel nunca
     * muestra menos de lo que mostraba antes de este cambio.
     */
    /**
     * El relacionado del credito aparece con dos nombres distintos en este
     * archivo: el filtro y el panel de detalle usan "creditocompras",
     * mientras las columnas de la tabla leian "creditos". Se aceptan los dos
     * para no quedar atados a cual devuelva el backend.
     */
    const creditoDe = (fila) => (fila?.creditocompras || fila?.creditos)?.[0];

    // Idem con factura y recibo: en compras el API devuelve facturacompras y
    // recibocompras. Las columnas leian facturas/recibos, los nombres de
    // ventas, que en una compra no existen.
    const facturaDe = (fila) => (fila?.facturacompras || fila?.facturas)?.[0];
    const reciboDe = (fila) => (fila?.recibocompras || fila?.recibos)?.[0];

    const fusionarDetalle = (anterior, detalle) => {
        const resultado = { ...anterior };
        Object.keys(detalle).forEach((clave) => {
            const valor = detalle[clave];
            if (valor !== undefined && valor !== null) {
                resultado[clave] = valor;
            }
        });
        return resultado;
    };

    /**
     * Pide la compra por id al seleccionarla, en lugar de depender de que el
     * listado haya traido todas las relaciones. Si la peticion falla se
     * queda lo del listado, sin molestar al usuario con un error.
     */
    const refrescarDetalleCompra = async (compra) => {
        if (!compra?.id) return;
        try {
            const { data } = await AxiosPrivado.get(CompraListarId + compra.id, {
                timeout: 20000,
            });
            const detalle = Array.isArray(data) ? data[0] : data;
            if (!detalle || !detalle.id) return;

            // Puede haber cambiado la seleccion mientras llegaba la respuesta.
            setCompraSeleccionada((previa) =>
                previa?.id === detalle.id ? fusionarDetalle(previa, detalle) : previa
            );
        } catch (error) {
            console.error("No se pudo refrescar el detalle de la compra:", error);
        }
    };

    const handleSeleccionarVenta = (compra) => {
        // Se pinta de inmediato con lo que ya hay para que el panel no quede
        // vacio, y el detalle se refresca cuando llega.
        setCompraSeleccionada(compra);
        setTimeout(() => {
            if (refEdicion.current) {
                refEdicion.current.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                });
            }
        }, 100);
        refrescarDetalleCompra(compra);
    };

    const Total = compraSeleccionada && compraSeleccionada.totalCompra
        ? parseFloat(compraSeleccionada.totalCompra)
        : 0;

    const totalVenta = compraSeleccionada ? parseFloat(compraSeleccionada.totalCompra || 0) : 0;

    const totalPagado = compraSeleccionada?.pagoCompras?.length
        ? compraSeleccionada.pagoCompras.reduce(
            (sum, pagoCompraItem) => sum + parseFloat(pagoCompraItem.pago.recibido || 0),
            0
        )
        : 0;

    const saldoPendiente = totalVenta - totalPagado;

    const validarAbonoCredito = ({ efectivo, tarjeta, transferencia, saldoPendiente }) => {
        const totalRecibido = efectivo + tarjeta + transferencia;
        if (totalRecibido <= 0) {
            return "Debe ingresar un monto mayor a cero.";
        }
        if (totalRecibido > saldoPendiente) {
            const cambioProducido = totalRecibido - saldoPendiente;
            if (tarjeta + transferencia > saldoPendiente) {
                return "El monto pagado con tarjeta o transferencia no puede exceder el saldo pendiente.";
            }
            if ((tarjeta + transferencia) > (saldoPendiente - cambioProducido)) {
                return "El cambio solo puede generarse por el exceso en efectivo.";
            }
        }
        if (efectivo === 0 && tarjeta + transferencia !== totalRecibido) {
            return "Cuando no se paga con efectivo, el total recibido debe coincidir con tarjeta y transferencia.";
        }
        if (efectivo > 0) {
            if ((tarjeta + transferencia) > totalRecibido) {
                return "La suma de tarjeta y transferencia no puede exceder el total recibido.";
            }
            const restante = totalRecibido - (tarjeta + transferencia);
            if (efectivo < restante) {
                return "El efectivo no cubre el resto del abono ingresado.";
            }
        }
        return null;
    };

    const validarReferencias = () => {
        let hayError = false;

        let nuevosErroresPos = {};
        let nuevosErroresTransferencia = {};

        Object.keys(montosPos).forEach(posId => {
            if (parseFloat(montosPos[posId] || 0) > 0) {
                const ref = referenciasPos[posId] || "";
                if (!/^\d{6,15}$/.test(ref)) {
                    nuevosErroresPos[posId] = "La referencia debe tener entre 6 y 15 dígitos numéricos.";
                    hayError = true;
                }
            }
        });

        Object.keys(montosTransferencia).forEach(cuentaId => {
            if (parseFloat(montosTransferencia[cuentaId] || 0) > 0) {
                const ref = referenciasTransferencia[cuentaId] || "";
                if (!/^\d{8,15}$/.test(ref)) {
                    nuevosErroresTransferencia[cuentaId] = "La referencia debe tener entre 8 y 15 dígitos numéricos.";
                    hayError = true;
                }
            }
        });

        setErroresReferenciaPos(nuevosErroresPos);
        setErroresReferenciaTransferencia(nuevosErroresTransferencia);

        if (hayError) {
            mostraAlertaError("Hay referencias inválidas. Verifica los campos marcados.", "Error de validación");
        }

        return !hayError;
    };

    const generarListaTransferencias = () => {
        const lista = Object.keys(montosTransferencia)
            .filter(cuentaId => parseFloat(montosTransferencia[cuentaId] || 0) > 0)
            .map(cuentaId => ({
                monto: parseFloat(montosTransferencia[cuentaId]),
                referencia: referenciasTransferencia[cuentaId] || "",
                cuentaId: parseInt(cuentaId, 10),
            }));
        return lista;
    };

    const generarListaPos = () => {
        const lista = Object.keys(montosPos)
            .filter(posId => parseFloat(montosPos[posId] || 0) > 0)
            .map(posId => ({
                monto: parseFloat(montosPos[posId]),
                referencia: referenciasPos[posId] || "",
                posId: parseInt(posId, 10),
            }));
        return lista;
    };

    const confirmarPagoCredito = async () => {
        if (!validarReferencias()) return;
        const esCredito = (compraSeleccionada?.creditocompras?.length || 0) > 0;
        const totalCompra = parseFloat(compraSeleccionada?.totalCompra || 0);
        const compraId = compraSeleccionada?.id;
        const efectivoNum = (datosPago.efectivo || []).reduce((acc, pago) => acc + parseFloat(pago.monto || 0), 0);
        const posNum = (datosPago.tarjeta || []).reduce((acc, pago) => acc + parseFloat(pago.monto || 0), 0);
        const transferenciaNum = (datosPago.transferencia || []).reduce((acc, pago) => acc + parseFloat(pago.monto || 0), 0);
        const totalRecibidoNum = efectivoNum + posNum + transferenciaNum;

        const totalPagado = (compraSeleccionada?.pagoCompras || []).reduce(
            (sum, pagoCompraItem) => sum + parseFloat(pagoCompraItem.pago.recibido || 0),
            0
        );

        const saldoActual = totalCompra - totalPagado;
        if (!esCredito) {
            mostraAlertaError("Esta compra no es a crédito.", "Error");
            return;
        }
        const mensajeError = validarAbonoCredito({
            efectivo: efectivoNum,
            tarjeta: posNum,
            transferencia: transferenciaNum,
            saldoPendiente: saldoActual
        });
        if (mensajeError) {
            mostraAlertaError(mensajeError, "Error");
            return;
        }
        if (!cajaId) {
            mostraAlertaError("Caja no autenticada");
            return;
        }
        // Para abonar, la caja TIENE que estar abierta. La guarda anterior
        // decia lo contrario: era el mensaje de HomeApertura, donde si aplica
        // (no se puede abrir una caja ya abierta), copiado a esta pantalla.
        if (!cajaAbierta) {
            mostraAlertaError("La caja no está abierta. No se puede registrar el abono.");
            return;
        }
        if (!compraId) {
            mostraAlertaError("No se encontró información válida de la compra.", "Error");
            return;
        }
        const nuevoPago = {
            fecha: moment().toISOString(),
            pago: totalRecibidoNum,
            recibido: totalRecibidoNum,
            documento: "CR",
            estado: "Completada",
            compraId,
            cajaId,
            efectivo: datosPago.efectivo || [],
            transferencia: generarListaTransferencias(),
            tarjeta: generarListaPos()
        };
        try {
            await AxiosPrivado.post(CompraPagaCredito, {
                pago: nuevoPago,
            });
            mostraAlertaOk("Pago registrado correctamente.", "Éxito");
            ActualizarLista(ComprasListar, setListaComprasFiltradas);
            setCompraSeleccionada(null);
            setModalOpen2(false);
            limpiarDatosPago();
            setTimeout(() => {
                window.scrollTo({ top: 0, behavior: "smooth" });
            }, 100);
        } catch (er) {
            const { response } = er;
            const msjError =
                response?.data?.msj ||
                response?.data?.error?.message ||
                "Ocurrió un error desconocido.";
            mostraAlertaError(msjError, "Error");
        }
    };

    const handleImprimirReporte = async (compra) => {
        Swal.fire({
            title: 'Generando PDF...',
            text: 'Por favor, espere un momento.',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        if (compra) {
            try {
                const blob = await pdf(<ReporteCredito compra={compra} />).toBlob();
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = `ReporteCredito_${compra.id}.pdf`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
                Swal.close();
            } catch (error) {
                Swal.close();
                mostraAlertaError("Error al generar el PDF. Inténtelo de nuevo.");
            }
        } else {
            Swal.close();
            mostraAlertaError("No se encontraron detalles para generar el reporte.", "Error");
        }
    };

    const columnas = useMemo(() => [
        { title: "ID", data: "id" },
        {
            title: "Proveedor",
            data: "proveedor",
            render: (proveedor) => {
                return proveedor && proveedor.nombre
                    ? proveedor.nombre
                    : "Sin proveedor";
            },
        },
        {
            title: 'Fecha',
            data: null,
            render: (rowData) => {
                const fechaStr =
                    facturaDe(rowData)?.fecha ||
                    reciboDe(rowData)?.fecha ||
                    creditoDe(rowData)?.fecha;
                if (fechaStr) {
                    const fecha = moment(fechaStr);
                    return fecha.isValid() ? fecha.format('DD/MM/YYYY') : '—';
                }
                return '—';
            },
        },
        {
            title: 'Fecha Vencimiento',
            data: null,
            render: (rowData) => {
                const fechaStr =
                    creditoDe(rowData)?.fechaVencimiento;
                if (fechaStr) {
                    const fecha = moment(fechaStr);
                    return fecha.isValid() ? fecha.format('DD/MM/YYYY') : '—';
                }
                return '—';
            },
        },
        {
            title: 'Dias Vencidos',
            data: null,
            render: (rowData) => {
                return creditoDe(rowData)?.diasMora;
            },
        },
        {
            title: "Total (L)",
            data: "totalVenta",
            render: (data) => {
                const valorFormateado = formatoMoneda(data);
                return `<span style="text-align: right; display: block;">${valorFormateado}</span>`;
            }
        },
        {
            title: "Saldo Pendiente (L)",
            data: null,
            render: (rowData) => {
                const valorFormateado = formatoMoneda(creditoDe(rowData)?.saldoActual || 0);
                return `<span style="text-align: right; display: block;">${valorFormateado}</span>`;
            }
        },
        {
            title: "Estado",
            data: null,
            render: (row) => {
                let badgeClass = "";
                switch (creditoDe(row)?.estado) {
                    case "Completada":
                        badgeClass = "bg-success text-white";
                        break;
                    case "Anulada":
                        badgeClass = "bg-info text-white";
                        break;
                    case "Pendiente":
                        badgeClass = "bg-warning text-dark";
                        break;
                    case "Mora":
                        badgeClass = "bg-danger text-white";
                        break;
                    default:
                        badgeClass = "bg-secondary text-white";
                }
                return `<span class="badge ${badgeClass}">${creditoDe(row)?.estado ?? "—"}</span>`;
            },
        },
        {
            title: "Acciones",
            data: null,
            orderable: false,
            className: "dt-center all",
            actions: [
                {
                    key: "ver",
                    className: "btn btn-outline-primary btn-sm",
                    icon: "fas fa-eye",
                    title: "Ver Detalles",
                    onClick: (rowData) => handleSeleccionarVenta(rowData)
                },
                {
                    key: "imprimirReporteCredito",
                    className: "btn btn-outline-success btn-sm my-1",
                    icon: "fas fa-chart-bar",
                    title: "Reporte de Compra",
                    onClick: (rowData) => handleImprimirReporte(rowData)
                }
            ]
        }
    ], []);

    const datos = {
        titulo: {
            titulo: "Gestion de credito de compra",
            url: "/app/admin/ventas/editar",
            tituloUrl: "Menu Principal",
            nombreUrl: "Edición",
        },
    };

    const creditosFiltrados = useMemo(() => {
        console.log("Ventas con crédito:", listaComprasFiltradas);
        let filtrados = listaComprasFiltradas.filter((v) => v.creditocompras?.length > 0);

        const startTimestamp = fechaInicio ? moment(fechaInicio).startOf('day').valueOf() : null;
        const endTimestamp = fechaFin ? moment(fechaFin).endOf('day').valueOf() : null;

        filtrados = filtrados.filter(v => {
            if (estadoFiltro !== "TODOS" && v.estado !== estadoFiltro) {
                return false;
            }

            if (startTimestamp || endTimestamp) {
                const fechaCreditoStr = v.creditocompras?.[0]?.fecha;

                if (!fechaCreditoStr) return false;

                const creditoTimestamp = moment(fechaCreditoStr).valueOf();

                if (startTimestamp && creditoTimestamp < startTimestamp) {
                    return false;
                }
                if (endTimestamp && creditoTimestamp > endTimestamp) {
                    return false;
                }
            }

            return true;
        });

        return filtrados;

    }, [listaComprasFiltradas, estadoFiltro, fechaInicio, fechaFin]);

    const handleFiltrar = () => {
        setEstadoFiltro(estadoFiltroTemp);
        setPanelAbierto(false);
    };

    const handleReset = () => {
        setFechaInicio(moment().subtract(1, "month").format("YYYY-MM-DD"));
        setFechaFin(moment().format("YYYY-MM-DD"));
        setEstadoFiltro("TODOS");
        setEstadoFiltroTemp("TODOS");
        setPanelAbierto(false);
    };

    return (
        <Page datos={datos}>
            <Card titulo="Listado de ventas - Credito">
                <div className="mb-4 d-flex justify-content-end">
                    <div className="position-relative">
                        {/* Botón para Abrir/Cerrar Panel */}
                        <button
                            className={`btn ${panelAbierto ? "btn-danger" : "btn-primary"} d-flex justify-content-between align-items-center`}
                            onClick={() => setPanelAbierto(!panelAbierto)}
                            style={{
                                borderRadius: "6px",
                                padding: "6px 12px",
                                fontSize: "0.9rem",
                                minWidth: "140px",
                            }}
                        >
                            <span className="d-flex align-items-center">
                                <i className="fas fa-filter mx-2"></i>
                                Filtros
                            </span>
                            <i className={`fas fa-chevron-${panelAbierto ? "up" : "down"}`}></i>
                        </button>

                        {/* Panel de Filtros */}
                        {panelAbierto && (
                            <div
                                className="position-absolute top-100 mt-2 bg-body border border-secondary-subtle text-body shadow"
                                style={{
                                    minWidth: "240px",
                                    right: 0,
                                    borderRadius: "10px",
                                    backgroundColor: "#fff",
                                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                                    padding: "15px",
                                    zIndex: 1050,
                                }}
                            >
                                <div className="mb-3">
                                    <label className="form-label">Fecha inicio</label>
                                    <input
                                        type="date"
                                        className="form-control form-control-sm"
                                        value={fechaInicio}
                                        onChange={(e) => setFechaInicio(e.target.value)}
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Fecha fin</label>
                                    <input
                                        type="date"
                                        className="form-control form-control-sm"
                                        value={fechaFin}
                                        onChange={(e) => setFechaFin(e.target.value)}
                                    />
                                </div>

                                <div className="form-group mb-3">
                                    <label htmlFor="estadoFiltroSelect" className="form-label fw-bold">Estado</label>
                                    <select
                                        id="estadoFiltroSelect"
                                        className="form-control form-control-sm"
                                        value={estadoFiltroTemp}
                                        onChange={(e) => setEstadoFiltroTemp(e.target.value)}
                                    >
                                        <option value="TODOS">Todos</option>
                                        <option value="Completada">Completada</option>
                                        <option value="Anulada">Anulada</option>
                                    </select>
                                </div>
                                {/* Botones de Acción */}
                                <div className="d-flex justify-content-end">
                                    {/* *** Aplica el filtro con el valor temporal *** */}
                                    <button className="btn btn-sm btn-primary mx-2" onClick={handleFiltrar}>
                                        <i className="fas fa-filter mx-1"></i> Filtrar
                                    </button>
                                    {/* *** Resetea a Facturas *** */}
                                    <button className="btn btn-sm btn-secondary" onClick={handleReset}>
                                        <i className="fas fa-sync-alt mx-1"></i> Reset
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <Tablas
                    datos={creditosFiltrados}
                    columnas={columnas}
                    id="tablaVentasCreditos"
                />
            </Card>
            {compraSeleccionada && (
                <div ref={refEdicion} className="mt-4">
                    <Card
                        className="p-4 shadow-lg rounded"
                        pie={
                            <>
                                {compraSeleccionada?.compranuladas?.length > 0 ? (
                                    <div className="alert alert-light mt-3 p-3 border-start border-5 border-danger shadow-sm">
                                        <div className="d-flex align-items-center">
                                            <i className="fas fa-exclamation-circle fa-2x me-3 text-danger"></i>
                                            <div>
                                                <h6 className="mb-0 text-danger fw-bold mx-2">IMPOSIBILIDAD DE REGISTRO</h6>
                                                <small className="mx-2">
                                                    La transacción tiene el estado ANULADO. No es posible procesar abonos
                                                    o pagos adicionales en documentos con este estatus.
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                ) : saldoPendiente > 0 ? (
                                    <ModalWizardBootstrap
                                        titulo={`Registrar abono a crédito #${compraSeleccionada?.id || "..."}`}
                                        modalIsOpen={modalOpen2}
                                        setModalIsOpen={setModalOpen2}
                                        nombreBoton={`Abonar ${formatoMoneda(saldoPendiente)}`}
                                        estiloBoton="btn btn-success mx-3"
                                        iconBoton="fas fa-hand-holding-usd mx-2"
                                        iconos={[
                                            "fas fa-receipt",
                                            "fas fa-check-circle",
                                        ]}
                                        onFinish={confirmarPagoCredito}
                                        pasos={[
                                            {
                                                etiqueta: "Nuevo Pago",
                                                contenido: (
                                                    <>
                                                        <p className="mt-3">
                                                            <strong>Total compra:</strong> {formatoMoneda(totalVenta)}<br />
                                                            <strong>Total abonado:</strong> {formatoMoneda(totalPagado)}<br />
                                                            <strong>Saldo pendiente:</strong> {formatoMoneda(saldoPendiente)}
                                                        </p>
                                                        <MetodosPagoDinamicos
                                                            esCompra={true}
                                                            efectivo={efectivo}
                                                            setEfectivo={setEfectivo}
                                                            montosPos={montosPos}
                                                            setMontosPos={setMontosPos}
                                                            referenciasPos={referenciasPos}
                                                            setReferenciasPos={setReferenciasPos}
                                                            erroresReferenciaPos={erroresReferenciaPos}
                                                            setErroresReferenciaPos={setErroresReferenciaPos}
                                                            montosTransferencia={montosTransferencia}
                                                            setMontosTransferencia={setMontosTransferencia}
                                                            referenciasTransferencia={referenciasTransferencia}
                                                            setReferenciasTransferencia={setReferenciasTransferencia}
                                                            erroresReferenciaTransferencia={erroresReferenciaTransferencia}
                                                            setErroresReferenciaTransferencia={setErroresReferenciaTransferencia}
                                                            pos={pos}
                                                            setPos={setPos}
                                                            transferencias={transferencias}
                                                            setTransferencias={setTransferencias}
                                                            formatoMoneda={formatoMoneda}
                                                            totalConRecargo={saldoPendiente}
                                                            totalRecibido={totalRecibido}
                                                        />
                                                    </>
                                                ),
                                            },
                                            {
                                                etiqueta: "Confirmación",
                                                contenido: (
                                                    <div className="text-center">
                                                        <i className="fas fa-check-circle fa-3x text-success mb-2" />
                                                        <p>¡Todo listo para un nuevo pago!</p>
                                                    </div>
                                                ),
                                            },
                                        ]}
                                    />
                                ) : (
                                    <div className="alert alert-info mt-3">
                                        <i className="fas fa-info-circle mx-2"></i>
                                        No se puede anular el pago porque la compra a crédito ya fue pagada por completo.
                                    </div>
                                )}
                            </>
                        }
                    >
                        {compraSeleccionada.compraDetalles?.length > 0 ? (
                            <div className="row justify-content-center">
                                <div className="col-12 p-0 border rounded shadow-sm">
                                    <div className="bg-gray text-white text-start py-3 rounded-top">
                                        <h4 className="mb-0 fw-light mx-4">Informe de movimiento de compra</h4>
                                        <p className="mb-0 text-whit mx-4">ID de Compra: <strong className="text-white">{compraSeleccionada.id || 'N/A'}</strong></p>
                                    </div>
                                    <div className="p-4">
                                        <h5 className="border-bottom pb-2 mb-3 text-primary">Detalle de productos adquiridos</h5>
                                        <div className="table-responsive">
                                            <table className="table table-sm table-striped table-bordered mb-4">
                                                <thead className="table-primary">
                                                    <tr>
                                                        <th className="text-center" style={{ width: '10%' }}>#</th>
                                                        <th>Producto</th>
                                                        <th className="text-end" style={{ width: '15%', textAlign: 'right' }}>Cantidad</th>
                                                        <th className="text-end" style={{ width: '20%', textAlign: 'right' }}>Costo unitario (L)</th>
                                                        <th className="text-end" style={{ width: '20%', textAlign: 'right' }}>Subtotal (L)</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {compraSeleccionada.compraDetalles.map((detalle, index) => (
                                                        <tr key={index}>
                                                            <td className="text-center">{index + 1}</td>
                                                            <td>{detalle.producto?.nombre || "Sin nombre"}</td>
                                                            <td className="text-end" style={{ textAlign: 'right' }}>{detalle.cantidad}</td>
                                                            <td className="text-end text-muted" style={{ textAlign: 'right' }}>
                                                                {formatoMoneda(parseFloat(detalle.costo))}
                                                            </td>
                                                            <td className="text-end fw-bold" style={{ textAlign: 'right' }}>
                                                                {formatoMoneda(detalle.cantidad * parseFloat(detalle.costo))}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="row mt-4 g-3">
                                            <div className="col-12 col-lg-6">
                                                <h5 className="border-bottom pb-2 mb-3 text-success">Resumen de totales</h5>
                                                {(() => {
                                                    const totalCompraCalculado = compraSeleccionada.compraDetalles.reduce((t, item) => t + item.cantidad * parseFloat(item.costo), 0);
                                                    const totalPagado = compraSeleccionada.pagoCompras
                                                        ?.filter(p => p.pago.estado !== "Anulada")
                                                        .reduce((sum, p) => sum + parseFloat(p.pago.recibido || 0), 0) || 0;
                                                    const saldoPendiente = Math.max(totalCompraCalculado - totalPagado, 0);
                                                    return (
                                                        <ul className="list-group list-group-flush border rounded">
                                                            <li className="list-group-item d-flex justify-content-between py-2">
                                                                <span className="fw-bold text-dark">Total neto de la compra:</span>
                                                                <span className="fw-bolder text-primary h5">{formatoMoneda(totalCompraCalculado)}</span>
                                                            </li>
                                                            <li className="list-group-item d-flex justify-content-between py-2 bg-light">
                                                                <span className="text-muted">Monto abonado / pagado:</span>
                                                                <span className="fw-bold text-success">{formatoMoneda(totalPagado)}</span>
                                                            </li>
                                                            <li className="list-group-item d-flex justify-content-between py-2">
                                                                <span className="fw-bolder h5 text-dark">SALDO PENDIENTE:</span>
                                                                <span className={`fw-bolder h4 ${saldoPendiente > 0 ? 'text-danger' : 'text-success'}`}>
                                                                    {formatoMoneda(saldoPendiente)}
                                                                </span>
                                                            </li>
                                                        </ul>
                                                    );
                                                })()}
                                            </div>
                                            <div className="col-12 col-lg-6">
                                                {compraSeleccionada.pagoCompras
                                                    ?.filter(item => item.pago?.estado !== "Anulada").length > 0 && (
                                                        <>
                                                            <h5 className="border-bottom pb-2 mb-3 text-secondary">Movimientos de pago</h5>
                                                            {(() => {
                                                                const obtenerLineasDePagoDetalladas = (pagoCompraItem, indice) => {
                                                                    const lineas = [];
                                                                    const datosBase = {
                                                                        fecha: pagoCompraItem.pago.fecha,
                                                                        documento: pagoCompraItem.pago.documento || `Abono #${indice + 1}`,
                                                                        pagoId: pagoCompraItem.pago.id,
                                                                    };
                                                                    let detalleEncontrado = false;
                                                                    pagoCompraItem.pago.pagoefectivos?.forEach((efectivo, idx) => {
                                                                        detalleEncontrado = true;
                                                                        lineas.push({
                                                                            ...datosBase,
                                                                            key: `${pagoCompraItem.pago.id}-efectivo-${idx}`,
                                                                            metodo: "Efectivo",
                                                                            monto: parseFloat(efectivo.monto || 0),
                                                                            cssClass: 'text-success' // Color verde
                                                                        });
                                                                    });
                                                                    pagoCompraItem.pago.pagotarjeta?.forEach((tarjeta, idx) => {
                                                                        detalleEncontrado = true;
                                                                        lineas.push({
                                                                            ...datosBase,
                                                                            key: `${pagoCompraItem.pago.id}-tarjeta-${idx}`,
                                                                            metodo: "Tarjeta (POS)",
                                                                            monto: parseFloat(tarjeta.monto || 0),
                                                                            cssClass: 'text-primary' // Color azul
                                                                        });
                                                                    });
                                                                    pagoCompraItem.pago.pagotransferencia?.forEach((transferencia, idx) => {
                                                                        detalleEncontrado = true;
                                                                        lineas.push({
                                                                            ...datosBase,
                                                                            key: `${pagoCompraItem.pago.id}-transferencia-${idx}`,
                                                                            metodo: "Transferencia",
                                                                            monto: parseFloat(transferencia.monto || 0),
                                                                            cssClass: 'text-warning' // Color naranja
                                                                        });
                                                                    });
                                                                    const montoPagoPrincipal = parseFloat(pagoCompraItem.pago.pago || 0);
                                                                    if (!detalleEncontrado && montoPagoPrincipal > 0) {
                                                                        lineas.push({
                                                                            ...datosBase,
                                                                            key: `${pagoCompraItem.pago.id}-generico-0`,
                                                                            metodo: "Pago Genérico (Sin desglose)",
                                                                            monto: montoPagoPrincipal,
                                                                            cssClass: 'text-secondary' // Color gris
                                                                        });
                                                                    }
                                                                    return lineas;
                                                                };
                                                                const todasLasLineasDePago = compraSeleccionada.pagoCompras
                                                                    .filter(item => item.pago?.estado !== "Anulada")
                                                                    .sort((a, b) => new Date(a.pago.fecha) - new Date(b.pago.fecha))
                                                                    .flatMap((pagoCompraItem, indice) => obtenerLineasDePagoDetalladas(pagoCompraItem, indice));
                                                                return (
                                                                    <div className="list-group">
                                                                        {todasLasLineasDePago.map(linea => (
                                                                            <div key={linea.key} className="list-group-item list-group-item-action d-flex justify-content-between align-items-center">
                                                                                <div>
                                                                                    <small className="text-muted d-block">{moment(linea.fecha).format("YYYY-MM-DD HH:mm")}</small>
                                                                                    <span className="fw-bold me-2">{linea.documento}</span>
                                                                                    <span className="badge bg-secondary mx-2">{linea.metodo}</span>
                                                                                </div>
                                                                                <span className={`${linea.cssClass} fw-bolder text-end`}>{formatoMoneda(linea.monto)}</span>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                );
                                                            })()}
                                                        </>
                                                    )}
                                            </div>
                                        </div>
                                    </div>
                                    {compraSeleccionada.pagoCompra?.filter(p => p.pago.estado === "Anulada").length > 0 && (
                                        <div className="bg-light p-3 border-top rounded-bottom">
                                            <div className="alert alert-warning py-2 mb-0 border-warning shadow-sm" role="alert">
                                                <h6 className="alert-heading mb-1"><i className="fas fa-exclamation-triangle me-2"></i>Advertencia: Pagos anulados</h6>
                                                <small>
                                                    Se han anulado {compraSeleccionada.pagoCompra.filter(p => p.pago.estado === "Anulada").length} pago(s). Estos montos no se incluyen en el cálculo del saldo:
                                                </small>
                                                <ul className="list-unstyled mb-0 mt-1 small">
                                                    {compraSeleccionada.pagoCompra
                                                        .filter(p => p.pago.estado === "Anulada")
                                                        .map(p => (
                                                            <li key={p.pago.id}>
                                                                <span className="text-danger">{moment(p.pago.fecha).format("YY-MM-DD HH:mm")}</span> — Doc: {p.pago.documento || 'N/A'} — Monto: <strong className="text-danger">L {parseFloat(p.pago.recibido).toFixed(2)}</strong>
                                                            </li>
                                                        ))}
                                                </ul>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        ) : (
                            <div className="alert alert-info text-center py-4 shadow-sm" role="alert">
                                <h5 className="mb-0">ℹ️ No hay detalles o movimientos de pago registrados para esta compra.</h5>
                            </div>
                        )}
                    </Card>
                </div>
            )}
        </Page>
    );
};

export default HomeCredito;